import threedocean from './3docean.json'
import audiojungle from './audiojungle.json'
import codecanyon from './codecanyon.json'
import graphicriver from './graphicriver.json'
import photodune from './photodune.json'
import themeforest from './themeforest.json'
import videohive from './videohive.json'

const configs = {
  '3docean': threedocean,
  audiojungle,
  codecanyon,
  graphicriver,
  photodune,
  themeforest,
  videohive
}

export const getTopCategoryLabel = (siteKey, key) => {
  const result = configs[siteKey].find(category => category.path === key)
  return result && result.name
}

export default configs



// WEBPACK FOOTER //
// ./config/sites/categories/index.js